import { i18n } from '@lingui/core';
import type { SelectedFilter as TSelectedFilter } from '@schibsted-nmp/search-frontend-clients/quest';
import { Pill } from '@warp-ds/react';
import React from 'react';
import { deleteParamValue, useSubmitSearch } from '../../../data/SearchQuery';

type SelectedFilterProps = {
    filter: TSelectedFilter;
    onOpen?: (filterName: string) => void;
};

export function SelectedFilter(props: SelectedFilterProps) {
    const { filter, onOpen } = props;

    const { submitSearch } = useSubmitSearch();

    const clearFilter = React.useCallback(() => {
        const selectedParameters = filter.parameters;

        submitSearch((urlParams) => {
            selectedParameters.forEach((selectedParam) => {
                const {
                    parameter_name: selectedName,
                    parameter_value: selectedValue,
                } = selectedParam;
                deleteParamValue(urlParams, selectedName, selectedValue);
            });
        });
    }, [filter, submitSearch]);

    const handleClick = React.useCallback(
        () => onOpen?.(filter.filter_name),
        [filter, onOpen],
    );

    return (
        <Pill
            suggestion
            canClose
            label={filter.display_name}
            onClick={handleClick}
            onClose={clearFilter}
            closeSRLabel={i18n.t({
                id: 'filters.selected.remove',
                message: 'Remove filter',
            })}
            openSRLabel={i18n.t({
                id: 'filters.selected.show',
                message: 'Show filter',
            })}
        />
    );
}
